export default "__VITE_ASSET__jT4SzfVs__"